import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogTitle, DialogContent, DialogActions} from 'views/components';
import {Typography, Button} from 'views/components';
import {Translate} from 'views/module';

const DeleteConfirmDialog = (props) => {
  const {
    setDialogOpen,
    onClickConfirmDelete,
  } = props;

  const closeModal = () => {
    setDialogOpen(false);
  };

  return (
    <Dialog onClose={closeModal}>
      <DialogTitle onClose={closeModal}>
        <Translate expression='generic.ConfirmTheAction'/>
      </DialogTitle>
      <DialogContent>
        <Typography>
          <Translate expression='generic.DeleteConfirm'/>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={closeModal}>
          <Translate expression='generic.Cancel'/>
        </Button>
        <Button onClick={onClickConfirmDelete}>
          <Translate expression='generic.Confirm'/>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
DeleteConfirmDialog.propTypes = {
  setDialogOpen: PropTypes.func.isRequired,
  onClickConfirmDelete: PropTypes.func.isRequired,
};

export default React.memo(DeleteConfirmDialog);
